import { useMutation } from "@apollo/client";
import { USE_QUICK_WESENTLICHKEIT } from "@services/graphql/mutations/useQuickWesentlichkeit";
import { FETCH_SUBSCRIPTION_INFO } from "@company/graphql/queries/fetchSubscriptionInfo";

/**
 * Hook zum Einreichen eines Quick-Wesentlichkeit-Jobs.
 *
 * Der Hook führt die gleichnamige GraphQL-Mutation aus, verbraucht damit einen Service-Credit
 * und legt serverseitig einen neuen ServiceJob (Status = PENDING) an. Anschließend werden die
 * Service-Credits im Cache aktualisiert.
 */
export const useQuickWesentlichkeit = () => {
    const [triggerMutation, { loading, error, data }] = useMutation(USE_QUICK_WESENTLICHKEIT, {
        // Service-Credits neu laden, um das verbrauchte Guthaben sofort zu reflektieren
        refetchQueries: [FETCH_SUBSCRIPTION_INFO],
    });

    /**
     * Reicht den Job ein.
     * Gibt `true` zurück, wenn der Backend-Aufruf erfolgreich war.
     */
    const submitJob = async (documents: string[] = []) => {
        const result = await triggerMutation({ variables: { documents } });
        return result.data?.useQuickWesentlichkeit ?? null;
    };

    return {
        submitJob,
        loading,
        error,
        job: data?.useQuickWesentlichkeit ?? null,
    };
}; 